import { ShieldCheck, Truck, RotateCcw, Lock } from "lucide-react";

const BADGES = [
  { icon: Truck, title: "Free Global Shipping", desc: "On orders over $75 to 190+ countries" },
  { icon: ShieldCheck, title: "Buyer Protection", desc: "Secure checkout & verified suppliers" },
  { icon: RotateCcw, title: "30-Day Returns", desc: "Easy, hassle-free refunds worldwide" },
  { icon: Lock, title: "Encrypted Payments", desc: "256-bit SSL secured transactions" },
];

export function TrustBadges() {
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {BADGES.map((b) => (
        <div key={b.title} className="dw-card flex items-start gap-3 rounded-xl p-4" data-testid={`trust-${b.title}`}>
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#00F0FF]/10 text-[#00F0FF]">
            <b.icon className="h-5 w-5" />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-100">{b.title}</p>
            <p className="mt-0.5 text-xs text-slate-400">{b.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
